import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import useSWR from "swr";
import { Heart } from "lucide-react";
import { listSupporters } from "@/lib/api";

export const SupporterWall = () => {
  const { data } = useSWR("/supporters", listSupporters);
  const items = data?.items || [];
  const { hash } = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    if (hash === "#supporter-wall" && data) ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [hash, data]);

  return (
    <section
      id="supporter-wall"
      ref={ref}
      className="mt-16 pt-10 border-t border-white/10 scroll-mt-24"
      data-testid="supporter-wall"
    >
      <div className="mono-label">Supporter wall</div>
      <h2 className="font-serif-editorial text-3xl sm:text-4xl text-[#f4f1ea] mt-3">
        Thank you, all of you.
      </h2>
      {items.length === 0 ? (
        <p className="mt-4 text-white/50 text-sm" data-testid="supporter-wall-empty">
          No names yet — tip and tap "I tipped" to be the first on the wall.
        </p>
      ) : (
        <ul className="mt-6 flex flex-wrap gap-2" data-testid="supporter-wall-list">
          {items.map((s, i) => (
            <li
              key={s.name}
              data-testid={`supporter-name-${i}`}
              className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-[#12141d] px-4 py-2 text-sm text-[#f4f1ea] hover:border-[#d95d39]/50 transition-colors"
            >
              <Heart className="w-3 h-3 text-[#d95d39]" />
              {s.name}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
